import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FlashcardModePage.css';
import { useLanguage } from '../contexts/LanguageContext';

function DemoFlashcardModePage() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="flashcard-mode-container" style={{ marginTop: '3.5rem' }}>
      <div className="flashcard-mode-content">
        <button 
          onClick={() => navigate(`/module/demo/group/0`)} 
          className="btn btn-secondary btn-back"
        >
          {t('backToModule')}
        </button>
        <div className="mode-selection-card">
          <h1>{t('chooseFlashcardMode')}</h1>
          <p className="mode-description">
            {t('selectHowToPractice')}
          </p>
          <div className="mode-options">
            <button 
              className="mode-option learning-mode" 
              onClick={() => navigate('/module/demo/group/0/flashcards-learning')}
              aria-label={t('startLearningMode')}
            >
              <div className="mode-icon">🎯</div>
              <h3>{t('learningMode')}</h3>
              <p className="mode-details">
                {t('learningModeDescription')}
              </p>
              <ul className="mode-features">
                <li>{t('learningModeFeature1')}</li>
                <li>{t('learningModeFeature2')}</li>
                <li>{t('learningModeFeature3')}</li>
                <li>{t('learningModeFeature4')}</li>
              </ul>
              <span className="btn btn-primary mode-btn">{t('startLearningMode')}</span>
            </button>
            <button 
              className="mode-option classic-mode" 
              onClick={() => navigate('/module/demo/group/0/flashcards')}
              aria-label={t('startClassicMode')}
            >
              <div className="mode-icon">📚</div>
              <h3>{t('classicMode')}</h3>
              <p className="mode-details">
                {t('classicModeDescription')}
              </p>
              <ul className="mode-features">
                <li>{t('classicModeFeature1')}</li>
                <li>{t('classicModeFeature2')}</li>
                <li>{t('classicModeFeature3')}</li>
                <li>{t('classicModeFeature4')}</li>
              </ul>
              <span className="btn btn-secondary mode-btn">{t('startClassicMode')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DemoFlashcardModePage; 